import { jsx as _jsx } from "react/jsx-runtime";
import { Icons } from '~/views/atoms/icons';
import { IconButton } from '@mui/material';
import React from 'react';
import { useStyles } from '~/views/molecules/dialog-buttons/styles';
export const CloseButton = ({ closeButtonHandler }) => {
    const classes = useStyles();
    return (_jsx(IconButton, { className: classes.button, color: "inherit", onClick: closeButtonHandler, children: _jsx(Icons.Close, { color: "primary" }) }));
};
